module.exports = __webpack_public_path__ + "static/img/face8.83f317f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face8.jpg
// module id = KncW
// module chunks = 0